var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Failure } from '~/ApiClient';
var SuccessfulStatus;
(function (SuccessfulStatus) {
    SuccessfulStatus[SuccessfulStatus["Ok"] = 200] = "Ok";
})(SuccessfulStatus || (SuccessfulStatus = {}));
var PigeonHandler = /** @class */ (function () {
    function PigeonHandler(accessTokenStorage, authProvider) {
        this.accessTokenStorage = accessTokenStorage;
        this.authProvider = authProvider;
    }
    PigeonHandler.prototype.decode = function (response, request) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var isJson, data, _c, errorCodes;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        isJson = (_b = (_a = response.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.startsWith('application/json')) !== null && _b !== void 0 ? _b : false;
                        if (!isJson) return [3 /*break*/, 2];
                        return [4 /*yield*/, response.json()];
                    case 1:
                        _c = _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _c = response.text();
                        _d.label = 3;
                    case 3:
                        data = _c;
                        if (SuccessfulStatus[response.status] !== undefined) {
                            // tslint:disable-line: strict-type-predicates
                            return [2 /*return*/, request.decode !== undefined ? request.decode(data) : data];
                        }
                        errorCodes = data.errors.map(function (error) { var _a, _b; return (_b = (_a = error.code) !== null && _a !== void 0 ? _a : error.title) !== null && _b !== void 0 ? _b : '<unknown>'; });
                        throw new Failure(new Set(errorCodes));
                }
            });
        });
    };
    PigeonHandler.prototype.prepare = function (urlRequest, request) {
        var _a, _b;
        if (!((_a = request.isAuthenticated) !== null && _a !== void 0 ? _a : true)) {
            return urlRequest;
        }
        var accessToken = this.accessTokenStorage.load();
        if (accessToken === null) {
            throw new Failure(new Set(['missing-access-token']));
        }
        return __assign(__assign({}, urlRequest), { headers: __assign(__assign({}, ((_b = urlRequest.headers) !== null && _b !== void 0 ? _b : {})), { 'X-Cogvio-Auth-Provider': this.authProvider, 'X-Cogvio-Auth-Token': accessToken }) });
    };
    return PigeonHandler;
}());
export { PigeonHandler };
